<template>
  <el-row
    type="flex"
    justify="end"
    class="view-action-buttons"
  >
    <el-col
      v-for="(button, index) in permittedButtons"
      :key="index"
      :span="3"
      class="view-action-buttons__column"
    >
      <el-button
        :type="button.type"
        :icon="button.icon"
        @click="button.action"
        class="view-action-buttons__item"
        :disabled="disabled"
      >
        {{ button.text }}
      </el-button>
    </el-col>
  </el-row>
</template>

<script>
  import acl from '@/services/acl';

  export default {
    name: 'ViewActionButtons',
    props: {
      buttons: { type: Array, default: () => [] },
      disabled: { type: Boolean, default: false },
    },
    data() {
      return {
        permittedButtons: [],
      };
    },
    created() {
      this.permittedButtons = this.buttons.filter((button) =>
        acl.userCanUse(button.permissions)
      );
    },
  };
</script>

<style lang="scss">
  .view-action-buttons {
    margin-top: 1.25rem;
    margin-bottom: 1.25rem;

    &__column {
      margin-left: 1rem;
    }

    // Same height as the tallest button in the row, label centered.
    &__item {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      white-space: normal;
    }
  }
</style>
